import { useState, useCallback } from "react";

const useAlertDialog = () => {
  const [isOpen, setIsOpen] = useState(false);

  const showDialog = useCallback(() => setIsOpen(true), []);
  const hideDialog = useCallback(() => setIsOpen(false), []);

  const AlertDialog = useCallback(
    ({ children }) => {
      if (!isOpen) return null;

      return (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/25"
          onClick={hideDialog}
        >
          <div
            className="bg-background p-5 rounded-2xl shadow-xl max-w-md mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-4">{children}</div>
            <div className="w-full flex justify-end">
              <button
                className="w-fit px-4 py-2 bg-secondary/90 text-background rounded-xl hover:bg-secondary/80 transition"
                onClick={hideDialog}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    },
    [isOpen, hideDialog]
  );

  return { showDialog, hideDialog, AlertDialog };
};

export default useAlertDialog;
